import React from 'react';
import Reveal from './Reveal';

const SectionTitle = ({ label, title, description, dark = false, align = 'left' }) => (
  <Reveal className={`section-title section-title--${align}${dark ? ' is-dark' : ''}`}>
    <p className="eyebrow">{label}</p>
    <h2>{title}</h2>
    {description && <p className="section-title__description">{description}</p>}
  </Reveal>
);

export default SectionTitle;
